import React from "react";
import Header from "../HomePage/Header";
import Lenders from "../HomePage/Lenders";
import Footer from "../HomePage/Footer";
const HomePage = () => {
  return (
    <>
      <Header />
      <Lenders />
      <Footer />
    </>
  );
};
export default HomePage;
